import QuestionsColumn from "./components/QuestionsColumn";
import { useQuery } from "@tanstack/react-query";
import { getQuestions } from "@/lib/services/questions";
import AnswerGroup from "./components/AnswerGroup";
import type { InspectionData } from "./inspection.d";
import { useEffect, useState } from "react";
import { usePhase } from "@/store/usePhase";
import { useDevice } from "@/store/useDevice";
import InspectionViewMobile from "./components/mobile/InpectionViewMobile";

const InspectionView = ({
  inspectionData,
}: {
  inspectionData: InspectionData;
}) => {
  const { setTasks } = usePhase();
  const [questions, setQuestion] = useState([]);
  const { isMobile } = useDevice();

  const { data: questionsData, isLoading } = useQuery({
    queryKey: ["questions", inspectionData.engineName],
    queryFn: () => getQuestions(inspectionData.inspectionTypeId),
  });

  useEffect(() => {
    if (questionsData) {
      setQuestion(questionsData);
      setTasks(questionsData.length);
    }
  }, [questionsData]);

  if (isLoading) return <div>Cargando...</div>;

  return (
    <div
      id="scrollable"
      className="min-h-0 overflow-y-auto overflow-x-auto max-w-full"
    >
      {isMobile ? (
        <InspectionViewMobile
          questions={questions}
          phases={inspectionData.phase}
        />
      ) : (
        <div className="w-full flex flex-row gap-x-2 px-[66px] py-6">
          <QuestionsColumn questions={questions} />
          {inspectionData.phase.map((phase) => {
            return (
              <AnswerGroup
                key={phase.phaseName}
                phase={phase}
                questions={questions}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default InspectionView;
